/** Returns the href only if it parses as an http(s) URL; otherwise "" (an inert
 * anchor). Defense-in-depth at any `<a href>` sink fed by quiz/persona data:
 * even though CTA hrefs are https-validated by the schema at boot, this blocks
 * `javascript:`/`data:`/`vbscript:` from ever reaching the DOM if a future code
 * path sources quiz content from the API instead of the validated bundle. */
export function safeHref(value: string | null | undefined): string {
  if (!value) return "";
  try {
    const u = new URL(value);
    return u.protocol === "https:" || u.protocol === "http:" ? value : "";
  } catch {
    return "";
  }
}
